// extracted by mini-css-extract-plugin
export default {"image":"NX-z","loaded":"OX-z"};